import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

// Initialize Firebase
var config = {
  apiKey: "AIzaSyBOlGfFEhbwlcp0QCH_rAPwUZPczF7nDf8",
  authDomain: "plan-mycreedo.firebaseapp.com",
  databaseURL: "https://plan-mycreedo.firebaseio.com",
  projectId: "plan-mycreedo",
  storageBucket: "plan-mycreedo.appspot.com",
  messagingSenderId: "281584407011"
};
firebase.initializeApp(config);
firebase.firestore().settings({ timestampsInSnapshots: true })

export default firebase;


// WEBPACK FOOTER //
// ./src/config/fbConfig.js